import { render, staticRenderFns } from "./linkSummary.static.vue?vue&type=template&id=a2b542a4"
import script from "./linkSummary.static.vue?vue&type=script&lang=js"
export * from "./linkSummary.static.vue?vue&type=script&lang=js"
import style0 from "./linkSummary.static.vue?vue&type=style&index=0&id=a2b542a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports